import React,{useState,useRef,useEffect} from "react";
import { Link,useHistory} from "react-router-dom";
import Footer from '../Global/Footer';
import Header from '../Global/Header';
import { admin_table_id } from './../Path.js';
import { DataStore } from '@aws-amplify/datastore';
import {Users} from './../models';
import { Amplify,Hub } from 'aws-amplify';
import awsconfig from './../aws-exports1';
var md5 = require('md5');
Amplify.configure(awsconfig);

function Login(){
    let history = useHistory();
  const email = useRef(null);
  const password = useRef(null);
	const [Opacity, setOpacity] = useState('1');
	// const [loginData, setLoginData] = useState([]);
	const [PointerEvents, setPointerEvents] = useState('');
  const [notification, setNotification] = useState({success:'',failed:'',show_success:false,show_failed:false});
	const [Loader, setLoader] = useState(false);
	const [errors, setErrors] = useState('');
    const handleValidation=()=>{
      let formIsValid = false;
        if(email.current.value===''){
          setErrors('Please enter email-id');		   
        }else if(password.current.value===''){
          setErrors('Please enter password');	
        }else {
          setErrors('');
          formIsValid = true;
        }	
      return formIsValid;
    }
    const login_data = async (event) => {
      event.preventDefault();
      if(handleValidation()){
        const original = await DataStore.query(Users, c => c.email("eq", email.current.value));
        setLoader(true);
        setOpacity('0.5');
        setPointerEvents('none');
        if((original[0].password===md5(password.current.value))){
        //   console.log(original[0].id);
          setLoader(false);
          setOpacity('');
          setPointerEvents('');
          localStorage.setItem('user_token',original[0].id);
            history.push('/profile');
        }else{
          setLoader(false);
          setOpacity('');
          setPointerEvents('');
          setNotification({success:'',failed:'Invalid credentials',show_failed:true,show_success:false});
        }
      }
    }

    return(

        <>   
        <Header />
<div className="container-fluid auth-bg">
    <div className="row">
    <h2 className='why-head heading'>Already a Member? Login Now!</h2>
        <div className="col-md-2">     
        </div>
         <center>
        <div className="col-md-8">
        <form className="form-horizontal auth">                 
            <div className="form-group">
                <label className="col-lg-3 control-label">Email:</label>
                <div className="col-lg-8">
                <input className="form-control" type="email" ref={email}/>
                </div>
            </div>             
            <div className="form-group">
                <label className="col-md-3 control-label">Password:</label>
                <div className="col-md-8">
                <input className="form-control" type="password" ref={password}/>
                </div>
            </div>
            {notification.show_success ? (<div className="alert alert-success" id="success2">{notification.success}
                <button type="button" className="close" data-dismiss="alert"></button>
            </div>) : ('')}		
            {notification.show_failed ? (<div className="alert alert-danger" id="danger2">{notification.failed}
                <button type="button" className="close" data-dismiss="alert"></button>
            </div>) : ('')}
            {errors ?(<div className="alert alert-danger" style={{color: "#721c24"}}>{errors}</div>):('')}
            <div className="form-group">
                <label className="col-md-3 control-label"></label>
                <div className="col-md-8 btn-block auth">

                <button className="custom-btn btn-banner" onClick={login_data} style={{opacity:Opacity,pointerEvents:PointerEvents}}>
                    {Loader ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>): ('')} Login
                </button>
                <span></span>
                </div>
            </div>
            </form>                   
        </div>
        </center>
        <div className="col-md-2">       
        </div>
</div>
</div>  
<Footer />
        </>
    )
}

export default Login;